import { Button, Card, Form, Input } from "antd";
import React from "react";
import l1 from "../../assets/l1.svg";
import logo from "../../assets/logo.svg";
import styles from "./index.less";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

export default function Login() {
  const navigate = useNavigate();
  const onFinish = (values) => {
    if (values["user"] !== "admin" && values["password"] !== "admin") {
      message.open({
        icon: <CloseCircleOutlined />,
        content: "用户名或密码错误!",
      });
    } else {
      message.open({
        icon: <CheckCircleOutlined />,
        content: "登录成功!",
      });
      navigate("/edit");
    }
  };

  return (
    <div className={styles.main}>
      <img
        src={l1}
        alt="bg"
        style={{ width: "100%", height: "100%" }}
        className={styles.bg}
      />
      <div className={styles.bottom}>
        <div className={styles.left}>
          <img
            src={logo}
            alt="logo"
            style={{ width: "150px", height: "150px" }}
          />
          <span>哩叩低代码平台✨</span>
        </div>
        <div className={styles.right}>
          <Card>
            <Form
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              autoComplete="off"
              onFinish={onFinish}
            >
              <Form.Item
                label="用户名"
                name="user"
                rules={[
                  {
                    required: true,
                    message: "请输入用户名!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="密码"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "请输入密码!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  offset: 18,
                  span: 8,
                }}
              >
                <Button type="primary" htmlType="submit">
                  登录
                </Button>
              </Form.Item>
              <span>
                &copy; Powered By{" "}
                <a href="https://github.com/Licodeao">Licodeao</a>
              </span>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
}
